import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
// The design-system stylesheet only. @huaca/ui exposes this as its own export, separate from the
// JS barrel — see RoomMark.tsx for why no component is imported from it.
import '@huaca/ui/styles.css';
import './room.css';
import { RoomApp } from './RoomApp';

// NO AuthProvider. This page has no platform session and must never acquire one: it is opened by an
// anonymous member of the public who has proved nothing yet.
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RoomApp />
  </StrictMode>,
);
